import React, { useState, useEffect } from 'react'
import { Modal, Button, Table, Text, Box, Flex, Badge, ScrollArea } from '@mantine/core'
import dayjs from 'dayjs'
import { currencyFormat } from 'simple-currency-format'

import { useCustomer } from '../../store/useCustomer'
import { useAuthStore } from '../../store/useAuthStore'
import { notifications } from '@mantine/notifications'

const ModalViewRecords = ({ isOpen, onClose, num_account, records, onSyncSuccess }) =>
{
  const { syncCustomersFromRecords } = useCustomer();
  const role = useAuthStore((s) => s.role);
  const [ syncing, setSyncing ] = useState(false);

  const close = () =>
  {
    onClose()
  }

  const handleSync = async () => {
    setSyncing(true);
    const res = await syncCustomersFromRecords(num_account);
    setSyncing(false);
    if (res?.status) {
      notifications.show({
        title: 'Fechas Sincronizadas',
        message: `Se actualizaron las fechas de la cuenta #${num_account} con el historial de pagos.`,
        color: 'green',
      });
      if (onSyncSuccess) onSyncSuccess();
    } else {
      notifications.show({
        title: 'Error',
        message: 'Ocurrió un error al sincronizar las fechas.',
        color: 'red',
      });
    }
  };

  return (
    <>
      <Modal 
        opened={ isOpen } 
        onClose={ close } 
        title={ `Historial de Pagos - Cuenta #${num_account}` } 
        centered
        size="xl"
        radius="lg"
      >
        <Box p="xs">
          <ScrollArea h={400}>
            <Table verticalSpacing="sm" highlightOnHover stickyHeader>
              <Table.Thead bg="gray.0">
                <Table.Tr>
                  <Table.Th>Fecha</Table.Th>
                  <Table.Th>Monto</Table.Th>
                  <Table.Th>Banco</Table.Th>
                  <Table.Th>Referencia</Table.Th>
                  <Table.Th>Estado</Table.Th>
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                { records && records.length > 0 ? records.map((record) => (
                  <Table.Tr key={ record._id }>
                    <Table.Td>
                      <Text size="sm" fw={500}>
                        { dayjs(record.created_date).format('DD/MM/YYYY') }
                      </Text>
                    </Table.Td>
                    <Table.Td>
                      <Text size="sm" fw={700} c="dark.4">
                        { currencyFormat(Number(record.amount), 'es-MX', 'MXN', 2) }
                      </Text>
                    </Table.Td>
                    <Table.Td>
                      <Text size="sm" c="dimmed">{ record.type_bank_name || '-' }</Text>
                    </Table.Td>
                    <Table.Td>
                      <Text size="xs" c="dimmed" style={{ fontFamily: 'monospace' }}>
                        { record.payment_reference || '-' }
                      </Text>
                    </Table.Td>
                    <Table.Td>
                      <Badge 
                        color={ record.status ? 'green' : 'red' } 
                        variant="light" 
                        size="sm"
                      >
                        { record.status ? 'Validado' : 'Cancelado' }
                      </Badge>
                    </Table.Td>
                  </Table.Tr>
                )) : (
                  <Table.Tr>
                    <Table.Td colSpan={5} align="center" py="xl">
                      <Text size="sm" c="dimmed">No hay registros para esta cuenta.</Text>
                    </Table.Td>
                  </Table.Tr>
                )}
              </Table.Tbody>
            </Table>
          </ScrollArea>

          <Flex justify="space-between" align="center" mt="xl">
            { role === 'SUPER_ADMIN' && (
              <Button 
                color="yellow" 
                variant="light" 
                loading={syncing}
                onClick={handleSync}
              >
                Sincronizar Fechas de esta Cuenta
              </Button>
            )}
            <Button color='gray' variant='light' onClick={ close }>
              Cerrar
            </Button>
          </Flex>
        </Box>
      </Modal>
    </>
  )
}

export default ModalViewRecords
